import OpportunityCard from './OpportunityCard.component';

export default OpportunityCard;